import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Resolve an uploaded/relative media path against the backend origin, ALWAYS
// routed through /api/static (the only path the ingress sends to the backend).
// Handles relative ("/static/..." or "/api/static/...") and absolute URLs, and
// heals older records that stored an absolute "https://host/static/uploads/..."
// (which 404'd because /static hits the frontend SPA, not the backend).
export const mediaUrl = (u) => {
  if (!u) return "";
  const s = String(u);
  const m = s.match(/\/(?:api\/)?static\/uploads\/[^?#"']+/);
  if (m) return `${BACKEND_URL}${m[0].replace(/^\/static\//, "/api/static/")}`;
  if (s.startsWith("http") || s.startsWith("data:")) return s;
  return `${BACKEND_URL}${s.startsWith("/") ? "" : "/"}${s}`;
};

export const TOKEN_KEY = "nowcommand_token";
export const getToken = () => {
  try { return localStorage.getItem(TOKEN_KEY); } catch (e) { return null; }
};
export const setToken = (t) => {
  try { t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY); } catch (e) { /* ignore */ }
};

export const api = axios.create({ baseURL: API, withCredentials: true });

// Attach the bearer token on every request. The httpOnly cookie still works for
// same-origin deploys, but a cross-origin API (e.g. custom domain frontend +
// emergent.host backend) cannot rely on a SameSite=lax cookie — the bearer
// header is immune to cross-site / third-party-cookie blocking.
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // bubble up; pages decide
    }
    return Promise.reject(err);
  }
);

export const fmt = {
  money(cents) {
    if (cents == null) return "$0";
    const n = cents / 100;
    return n % 1 === 0 ? `$${n.toFixed(0)}` : `$${n.toFixed(2)}`;
  },
  date(iso) {
    if (!iso) return "";
    try {
      return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
    } catch (e) { console.error("Date formatting failed", e); return iso; }
  },
  datetime(iso) {
    if (!iso) return "";
    try {
      return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
    } catch (e) { console.error("Datetime formatting failed", e); return iso; }
  },
};
